export default __webpack_public_path__ + "static/knifeedge-eb7a266ea35380a114b51aadb593f99b.png";